function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 48,
  height: 48,
  rx: 12,
  fill: "url(#paint0_linear_5049_5798)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2148 19.4487H34.1158L33.887 31.1112L20.6085 34L13.3579 29.1377L13.2148 19.4487Z",
  fill: "#AB5500"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6085 34V19.4487H13.2148L13.3579 29.1377L20.6085 34Z",
  fill: "url(#paint1_radial_5049_5798)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6055 19.4487V34L33.884 31.1112L34.1128 19.4487H20.6055Z",
  fill: "url(#paint2_radial_5049_5798)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.0501 19.8061L20.5152 24.0392L34.2585 21.5151L34.33 17.7611L13 16.1165L13.0501 19.8061Z",
  fill: "#AB5500"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 16.1165L20.5152 20.1708V24.0392L13.0501 19.8061L13 16.1165Z",
  fill: "url(#paint7_radial_5049_5798)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.5156 20.171L34.3304 17.7612L34.2589 21.5153L20.5156 24.0394V20.171Z",
  fill: "url(#paint8_radial_5049_5798)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 16.1166L20.5152 20.1709L34.33 17.7612L26.2213 14L13 16.1166Z",
  fill: "url(#paint9_radial_5049_5798)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9258 17.6898C16.7123 18.1618 20.0945 20.0852 20.2733 20.2926C20.4521 20.5 20.4664 21.3294 20.5164 23.2887C20.5406 22.3046 20.6266 21.3231 20.7738 20.3498C20.9597 20.1997 32.0502 18.2047 33.6448 17.8829C31.2779 18.2619 20.9168 19.9422 20.5593 19.9494C20.0087 19.8564 17.0341 18.2404 15.9258 17.6898Z",
  fill: "#FF6A66"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.1942 32.1693C17.4077 31.6974 16.5281 31.111 15.7773 30.5819V30.7607L18.2014 32.3838V32.1693H18.1942Z",
  fill: "#936037"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.8851 32.0122C27.977 32.2553 27.026 32.477 26.125 32.6629V32.8059L28.8779 32.2053V32.0122H28.8851Z",
  fill: "#B17F4A"
});

var _ref13 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_5049_5798",
  x1: 24,
  y1: 0,
  x2: 24,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#86DDF9"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4070BC"
})), React.createElement("radialGradient", {
  id: "paint1_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.3793 21.7655) scale(14.6085)"
}, React.createElement("stop", {
  stopColor: "#FF6163"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8F0000"
})), React.createElement("radialGradient", {
  id: "paint2_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.2937 11.0469) scale(26.0493)"
}, React.createElement("stop", {
  stopColor: "#E60E10"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#730000"
})), React.createElement("radialGradient", {
  id: "paint3_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.0074 25.97) scale(8.53772)"
}, React.createElement("stop", {
  offset: 0.54,
  stopColor: "white"
}), React.createElement("stop", {
  offset: 0.58,
  stopColor: "#F9F5F6"
}), React.createElement("stop", {
  offset: 0.66,
  stopColor: "#EADADF"
}), React.createElement("stop", {
  offset: 0.76,
  stopColor: "#D1ADB8"
}), React.createElement("stop", {
  offset: 0.87,
  stopColor: "#AE7083"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#822341"
})), React.createElement("radialGradient", {
  id: "paint4_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.3859 20.8216) scale(17.3829 17.3829)"
}, React.createElement("stop", {
  offset: 0.54,
  stopColor: "white"
}), React.createElement("stop", {
  offset: 0.58,
  stopColor: "#F9F5F6"
}), React.createElement("stop", {
  offset: 0.66,
  stopColor: "#EADADF"
}), React.createElement("stop", {
  offset: 0.76,
  stopColor: "#D1ADB8"
}), React.createElement("stop", {
  offset: 0.87,
  stopColor: "#AE7083"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#822341"
})), React.createElement("radialGradient", {
  id: "paint5_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.5286 31.8834) scale(13.4787 13.4787)"
}, React.createElement("stop", {
  offset: 0.54,
  stopColor: "white"
}), React.createElement("stop", {
  offset: 0.58,
  stopColor: "#FAF6F5"
}), React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EDDEDA"
}), React.createElement("stop", {
  offset: 0.73,
  stopColor: "#D7B7AD"
}), React.createElement("stop", {
  offset: 0.84,
  stopColor: "#B98270"
}), React.createElement("stop", {
  offset: 0.95,
  stopColor: "#933E22"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#822000"
})), React.createElement("radialGradient", {
  id: "paint6_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.8214 31.6046) scale(12.2345 12.2345)"
}, React.createElement("stop", {
  offset: 0.54,
  stopColor: "white"
}), React.createElement("stop", {
  offset: 0.58,
  stopColor: "#FAF6F5"
}), React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EDDEDA"
}), React.createElement("stop", {
  offset: 0.73,
  stopColor: "#D7B7AD"
}), React.createElement("stop", {
  offset: 0.84,
  stopColor: "#B98270"
}), React.createElement("stop", {
  offset: 0.95,
  stopColor: "#933E22"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#822000"
})), React.createElement("radialGradient", {
  id: "paint7_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.7805 16.4311) scale(16.1816)"
}, React.createElement("stop", {
  stopColor: "#FF6163"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8F0000"
})), React.createElement("radialGradient", {
  id: "paint8_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.3687 4.43982) scale(20.9224 20.9224)"
}, React.createElement("stop", {
  stopColor: "#E60E10"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#730000"
})), React.createElement("radialGradient", {
  id: "paint9_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.5059 22.8952) scale(31.9056 31.9056)"
}, React.createElement("stop", {
  stopColor: "#F23559"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C40000"
})), React.createElement("radialGradient", {
  id: "paint10_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(33.4152 23.6175) scale(19.1562)"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9A8A"
})), React.createElement("radialGradient", {
  id: "paint11_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.0983 29.438) scale(22.4669)"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9A8A"
})), React.createElement("radialGradient", {
  id: "paint12_radial_5049_5798",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.0783 6.51333) scale(17.8477)"
}, React.createElement("stop", null), React.createElement("stop", {
  offset: 1,
  stopColor: "#CA9E67"
})));

var SvgTicketPromote = function SvgTicketPromote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.623 29.7312C14.2919 29.5424 14.0054 29.2843 13.7832 28.9745C13.5611 28.6647 13.4085 28.3106 13.3359 27.9364V29.1162L20.608 34.0215V32.6557C20.465 33.0276 19.943 33.0633 19.5211 32.8774C17.8003 31.9726 16.1614 30.9199 14.623 29.7312Z",
    fill: "url(#paint3_radial_5049_5798)"
  }), React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6055 32.6557V34.0215L33.884 31.1613L33.9197 29.202C33.7195 29.9814 33.3334 30.4319 32.2036 30.9396C29.2899 32.0526 26.253 32.8113 23.1582 33.1992C21.9927 33.3279 20.7842 33.3064 20.6055 32.6986V32.6557Z",
    fill: "url(#paint4_radial_5049_5798)"
  }), React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2305 20.8716V19.8992L20.6098 24.0107V25.7697C20.1093 24.1108 14.6463 20.4355 13.2305 20.8716Z",
    fill: "url(#paint5_radial_5049_5798)"
  }), React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6055 25.7841C21.8711 23.5316 31.2812 21.8656 34.0556 22.3661V21.0504L20.6055 23.7819V25.7841Z",
    fill: "url(#paint6_radial_5049_5798)"
  }), _ref6, _ref7, _ref8, _ref9, React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.103 23.4745C21.8887 23.174 21.7735 22.814 21.7735 22.4449C21.7735 22.0757 21.8887 21.7157 22.103 21.4152C23.1613 20.2568 32.0637 18.083 33.5224 18.6837C34.166 18.9482 34.2875 20.2067 34.2375 20.8288C34.2131 21.1182 34.0951 21.3918 33.9014 21.6082L34.2804 21.5367L34.3519 17.7827L20.5156 20.171V24.0108L22.5178 23.6461C22.365 23.615 22.2225 23.5461 22.103 23.4459V23.4745Z",
    fill: "url(#paint10_radial_5049_5798)"
  }), React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4362 19.792C13.2431 19.2986 13.0644 18.0401 13.4505 17.5753C14.0869 16.8602 15.7959 17.8041 16.3965 18.1044C17.4405 18.6479 19.2925 19.7204 19.8073 20.7787C19.9767 21.1213 20.0924 21.4879 20.1505 21.8656C20.222 22.2589 20.1505 23.2957 19.7072 23.4459C19.6316 23.4604 19.554 23.4604 19.4784 23.4459L20.508 24.0322V20.1709L13 16.1452L13.0501 19.8063L13.6221 20.128C13.5397 20.0286 13.4767 19.9146 13.4362 19.792Z",
    fill: "url(#paint11_radial_5049_5798)"
  }), React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0593 16.238C15.3819 15.8933 15.8092 15.6646 16.2749 15.5873L13 16.1451L20.5152 20.1708L34.33 17.7611L32.3779 16.8601C32.571 17.2534 32.2778 17.5752 31.5413 17.8183C28.3843 18.6808 25.1473 19.2175 21.8809 19.42C21.4294 19.4413 20.9769 19.4198 20.5295 19.3557C18.7503 19.0233 17.0702 18.2897 15.6171 17.2105C15.0951 16.8315 14.902 16.4955 15.0593 16.2523V16.238Z",
    fill: "url(#paint12_radial_5049_5798)"
  }), _ref10, React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref11), React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _ref12), _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTicketPromote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ticket-promote.46a72cbe.svg";
export { ForwardRef as ReactComponent };